var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main---search",
    transform: "translate(-38.000000, -334.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(38.000000, 334.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M10.7,2.8v10c0,0.3,0.2,0.5,0.5,0.5h10c-0.3,5.3-4.6,9.5-10,9.5c-5.6,0-10.1-4.5-10.1-10.1 C1.2,7.4,5.4,3.1,10.7,2.8z M11.2,1.7c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1c0-0.3-0.2-0.5-0.5-0.5H11.7 V2.2C11.7,1.9,11.5,1.7,11.2,1.7z M13.3,1.2c5.1,0.3,9.2,4.3,9.5,9.5h-9.5C13.3,10.7,13.3,1.2,13.3,1.2z M12.8,0.1 c-0.3,0-0.5,0.2-0.5,0.5v10.6c0,0.3,0.2,0.5,0.5,0.5h10.6c0.3,0,0.5-0.2,0.5-0.5C23.9,5.1,18.9,0.1,12.8,0.1z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharticon);
export default __webpack_public_path__ + "static/media/chart.icon.148f98a2ce6db9737ae5399c50221fac.svg";
export { ForwardRef as ReactComponent };